import template from "./proxy-response-iframe.html";

export default angular.module("vesl.components.proxy-response-iframe", []).component("proxyResponseIframe", {
	bindings: {
		content: "<"
	},
	template
}).name;
